// extracted by mini-css-extract-plugin
export default {"clientGalleryPhoto":"ClientGalleryPhoto_clientGalleryPhoto__KDFHi"};